import type { CriterionLocaleBundle } from '../localize'

/** Unofficial translations from docs/kata — English scoring text remains authoritative. */
export const nageNoKataCriteriaI18n: CriterionLocaleBundle = {
  "ja": {
    "nage-gen-start-pos": {
      "text": "取が開始位置を決める。"
    },
    "nage-gen-engagement-pull": {
      "text": "組み始めの間合い。受は右／左足を踏み出し、右／左の基本の組み方で取を握り始める。取はこれに応じて組み、後退しながら受を前方へ引いて崩す（浮落、肩車、払腰、釣込腰、支釣込足、横掛）。 組み始めの間合い。受は右／左足を踏み出し、右／左の基本の組み方で取を握り始める。取はこれに応じて組み、両者は右／左自然体（migi/hidari shizen-tai）になる。取は歩み足（Ayumi-ashi）で前進し、受を後方へ押して崩す（巴投）。"
    },
    "nage-gen-tsugi-ashi": {
      "text": "継ぎ足（Tsugi-ashi）の歩法（浮落、肩車、払腰、釣込腰、支釣込足、横掛）。"
    },
    "nage-gen-blow": {
      "text": "取と受は中央付近で三歩、約 1.8 m の間合いを取り、受が取の頭頂を打つ（背負投、浮腰、裏投、横車）。",
      "hint": "受が取の頭への打撃を横から行う場合は中（Medium）"
    },
    "nage-gen-okuri": {
      "text": "取と受は中央付近で組み始めの間合いを取る。受は右／左の基本の組み方で取を握り始め、取はこれに応じて組み、受を横へ押して崩す。両者は横に移動する（送足払）。"
    },
    "nage-gen-uchi-mata": {
      "text": "取と受は中央付近で組み始めの間合いを取り、前へ踏み出して立ち、受が取を握り始める。両者は右／左自然体で基本の組み方をする（内股）。",
      "hint": "後ろへ踏み出す場合は中（Medium）"
    },
    "nage-gen-tomoe-pos": {
      "text": "取と受は中央から受側へ約 1 m の位置で組み始めの間合いを取り、前へ踏み出して立ち、受が取を握り始める。両者は右／左自然体で基本の組み方をする（巴投）。",
      "hint": "後ろへ踏み出す場合は中（Medium）"
    },
    "nage-gen-jigotai": {
      "text": "取と受は一歩の間合いを取り、右／左自護体（migi/hidari jigotai）で組む（隅返、浮技）。"
    },
    "nage-gen-direction-fall": {
      "text": "技の方向と倒れ方。巴投と隅返では、受は右／左足を前に進めて倒れ、その後、自然本体（shizen-hon-tai）で立つ。横車と浮技では、受身の後に自然本体で立つ。裏投では立ち上がらない。横掛では体と両脚を伸ばして倒れる。"
    },
    "nage-uki-otoshi-1": {
      "text": "受が組む。取は継ぎ足で後退する際に腕を上げず、三歩目を大きく踏み、引き落として受を投げる。"
    },
    "nage-uki-otoshi-2": {
      "text": "受は投げられる際に跳ばない。"
    },
    "nage-uki-otoshi-3": {
      "text": "取は前方を見て技を終える。"
    },
    "nage-uki-otoshi-4": {
      "text": "取の膝の位置はやや内側。"
    },
    "nage-seoi-nage-1": {
      "text": "受は左足・右足／右足・左足の順に二歩前進して攻撃する。"
    },
    "nage-seoi-nage-2": {
      "text": "取は受を前方へ崩し、自分の右／左肩に乗せて投げる。"
    },
    "nage-seoi-nage-3": {
      "text": "受の防御：両足をそろえ、崩し（Kuzushi）によって踵が浮く。左／右の手のひらを取の左／右腰に当てる。"
    },
    "nage-kata-guruma-1": {
      "text": "取は二歩目で袖の握りを変える。三歩目は大きくする。"
    },
    "nage-kata-guruma-2": {
      "text": "受は体を固くして防御する。"
    },
    "nage-kata-guruma-3": {
      "text": "取は外側の脚を移して持ち上げる位置に入り、受の下穿きをつかまない。"
    },
    "nage-uki-goshi-1": {
      "text": "受は左足・右足／右足・左足の順に二歩前進して攻撃する。"
    },
    "nage-uki-goshi-2": {
      "text": "取は攻撃に合わせて踏み込み、受を斜めに投げる。受は防御しない。"
    },
    "nage-harai-goshi-1": {
      "text": "取は二歩目で襟の握りを変え、受の左／右腋下を通して左／右肩甲骨に手を当てる。"
    },
    "nage-harai-goshi-2": {
      "text": "取は三歩目で作り（tsukuri）／崩し（kuzushi）の位置に入る。"
    },
    "nage-harai-goshi-3": {
      "text": "受の防御：両足がほぼそろい、崩しによって踵が浮く。"
    },
    "nage-harai-goshi-4": {
      "text": "取は脚を伸ばして払う。"
    },
    "nage-tsurikomi-goshi-1": {
      "text": "三歩目で取は右／左足を受の右／左足の前に移し、受を前へ引く。"
    },
    "nage-tsurikomi-goshi-2": {
      "text": "受の防御：両足をそろえ、踵を上げずに上体を後ろへ反らす。"
    },
    "nage-tsurikomi-goshi-3": {
      "text": "取は受を前方へ崩し、直ちに左／右足を引いて回り、腰を受の大腿に密着させて非常に低く入る。受の踵は取に崩された時にのみ浮く。"
    },
    "nage-okuri-ashi-harai-1": {
      "text": "取は二歩目と三歩目でリズムを変え、崩しを行う。"
    },
    "nage-okuri-ashi-harai-2": {
      "text": "取は水平に払い、受の体を持ち上げずに、受が移動する方向へ投げる。"
    },
    "nage-sasae-1": {
      "text": "二歩目の後、取は斜め後方へ移動する。"
    },
    "nage-sasae-2": {
      "text": "取は三歩目で右／左足を軸に回って受を投げる。前へ踏み出してはならない。"
    },
    "nage-uchi-mata-1": {
      "text": "取は大きな円運動で受を回し、両腕で水平に引く。"
    },
    "nage-uchi-mata-2": {
      "text": "三回目の回転で、取は受の進んでくる脚を上方、外方へ払い上げる。"
    },
    "nage-tomoe-1": {
      "text": "取は歩み足で前進し、受を後方へ崩す。"
    },
    "nage-tomoe-2": {
      "text": "受は三歩目で押し返して前へ踏み出し、両足をそろえて抵抗する。"
    },
    "nage-tomoe-3": {
      "text": "受が押し返し始めたら、取は握りを変え、左／右足を受の両足の間に踏み入れる。体を下げ、前上方へ引き上げて受を崩す。"
    },
    "nage-tomoe-4": {
      "text": "受が両足をそろえて踵を浮かせるのと同時に、取は右／左足を受の腹に当て、自分の頭上を越して投げる。"
    },
    "nage-ura-1": {
      "text": "受は左足・右足／右足・左足の順に二歩前進して攻撃する。"
    },
    "nage-ura-2": {
      "text": "取は二歩目に受の打撃をかわし、非常に低く左足・右足／右足・左足の順に踏み込む。両足で同時に跳び込んではならない。左／右腕を受の腰に回して引きつけ、右／左の手のひらを受の下腹部に当てる。"
    },
    "nage-ura-3": {
      "text": "取は自分の左／右肩の上を越して受を投げ、両肩を畳につけて終える。"
    },
    "nage-sumi-1": {
      "text": "取は自護体で後退しながら右／左腕を上げ、受を崩す。"
    },
    "nage-sumi-2": {
      "text": "受は均衡を保つため、右／左足を前に進めて両足を平行にし、防御の自護体になる。"
    },
    "nage-sumi-3": {
      "text": "取は右／左足を受の両足の間に置き、再び前方へ崩してから頭上を越して投げる。"
    },
    "nage-yoko-gake-1": {
      "text": "取は三歩目、半歩のところで受を右／左前隅へ傾けて崩し、横に投げる。"
    },
    "nage-yoko-gake-2": {
      "text": "取は右／左足をゆっくり後退させ、その足が他方の足の横に来たら直ちに左／右足で受の足首を押す。左／右手で受の右／左袖をすくい上げながら、受の体を自分の横へ投げる。"
    },
    "nage-yoko-guruma-1": {
      "text": "受は左足・右足／右足・左足の順に二歩前進して攻撃する。"
    },
    "nage-yoko-guruma-2": {
      "text": "取は裏投を試みる。"
    },
    "nage-yoko-guruma-3": {
      "text": "受は前屈して防御する。"
    },
    "nage-yoko-guruma-4": {
      "text": "取は受を前方へ崩し、右／左脚を受の両脚の間に深く滑り込ませる。"
    },
    "nage-yoko-guruma-5": {
      "text": "取は左／右側に横たわり、受を斜めに投げる。"
    },
    "nage-uki-waza-1": {
      "text": "取は自護体で後退しながら右／左腕を上げ、受を崩す。"
    },
    "nage-uki-waza-2": {
      "text": "受は均衡を保つため、右／左足を前に進めて自護体になる。"
    },
    "nage-uki-waza-3": {
      "text": "取は受を斜め前方へ崩し、自分の横に身を倒して受を斜めに投げる。"
    }
  },
  "zh-Hant": {
    "nage-gen-start-pos": {
      "text": "取決定起始位置。"
    },
    "nage-gen-engagement-pull": {
      "text": "接觸距離：受右／左腳向前踏出，以右／左基本握法開始握取；取回應握持，後退並將受向前拉，使其失去平衡（浮落、肩車、払腰、釣込腰、支釣込足、横掛）。 接觸距離：受右／左腳向前踏出，以右／左基本握法開始握取；取回應握持，雙方採右／左自然體（migi/hidari shizen-tai）；取以步足（Ayumi-ashi）向前進，將受向後推，使其失去平衡（巴投）。"
    },
    "nage-gen-tsugi-ashi": {
      "text": "繼足（Tsugi-ashi）的步法：浮落、肩車、払腰、釣込腰、支釣込足、横掛。"
    },
    "nage-gen-blow": {
      "text": "雙方位於中央區域，相距三步，約 1.8 米；受攻擊取的頭頂（背負投、浮腰、裏投、横車）。",
      "hint": "若受的頭部打擊為側向，則為中等（Medium）"
    },
    "nage-gen-okuri": {
      "text": "雙方位於中央區域，採接觸距離；受以右／左基本握法開始握取；取回應握持，將受向側方推，使其失去平衡；雙方側向移步（送足払）。"
    },
    "nage-gen-uchi-mata": {
      "text": "雙方位於中央區域，採接觸距離，向前踏步站定，受開始握取，雙方採右／左自然體，以基本握法相握（内股）。",
      "hint": "後退踏步為中等錯誤（Medium）"
    },
    "nage-gen-tomoe-pos": {
      "text": "雙方位於中央往受的一側約 1 米處，採接觸距離，向前踏步站定，受開始握取，雙方採右／左自然體，以基本握法相握（巴投）。",
      "hint": "後退踏步為中等錯誤（Medium）"
    },
    "nage-gen-jigotai": {
      "text": "雙方相距一步，採右／左自護體（migi/hidari jigotai）；握法（隅返、浮技）。"
    },
    "nage-gen-direction-fall": {
      "text": "施技方向及倒地方式：巴投與隅返中，受右／左腳前進作倒地動作，之後以自然本體（shizen-hon-tai）站起；横車及浮技中，受在倒地後以自然本體站起；裏投中，受不站起；横掛中，受身體及雙腿伸直倒地。"
    },
    "nage-uki-otoshi-1": {
      "text": "受握取；取以繼足後退時不抬高雙臂，第三步大步後退時向下拉，摔出受。"
    },
    "nage-uki-otoshi-2": {
      "text": "受被摔出時不跳起。"
    },
    "nage-uki-otoshi-3": {
      "text": "取完成技術時目視前方。"
    },
    "nage-uki-otoshi-4": {
      "text": "取的膝部位置，稍向內。"
    },
    "nage-seoi-nage-1": {
      "text": "受前進兩步攻擊，左腳、右腳／右腳、左腳。"
    },
    "nage-seoi-nage-2": {
      "text": "取使受向前失去平衡，將受承載於自己的右／左肩上摔出。"
    },
    "nage-seoi-nage-3": {
      "text": "受的防守：雙腳對齊，因崩（Kuzushi）而腳跟抬起；左／右掌置於取的左／右髖部。"
    },
    "nage-kata-guruma-1": {
      "text": "取在第二步改變袖部握法，第三步較大。"
    },
    "nage-kata-guruma-2": {
      "text": "受繃緊身體防守。"
    },
    "nage-kata-guruma-3": {
      "text": "取移至舉起受的位置，移動外側腿，不抓受的褲子。"
    },
    "nage-uki-goshi-1": {
      "text": "受前進兩步攻擊，左腳、右腳／右腳、左腳。"
    },
    "nage-uki-goshi-2": {
      "text": "取踏入迎接攻擊，將受斜向摔出；受不防守。"
    },
    "nage-harai-goshi-1": {
      "text": "取在第二步將握襟的手經受的左／右腋下，改握至受的左／右肩胛部。"
    },
    "nage-harai-goshi-2": {
      "text": "取在第三步就位，完成作（tsukuri）／崩（kuzushi）。"
    },
    "nage-harai-goshi-3": {
      "text": "受的防守：雙腳幾乎對齊，因崩而腳跟抬起。"
    },
    "nage-harai-goshi-4": {
      "text": "取以伸直的腿掃動。"
    },
    "nage-tsurikomi-goshi-1": {
      "text": "第三步時，取將右／左腳移至受右／左腳前方，將受向前拉。"
    },
    "nage-tsurikomi-goshi-2": {
      "text": "受的防守：雙腳對齊，上身後仰，腳跟不抬起。"
    },
    "nage-tsurikomi-goshi-3": {
      "text": "取使受向前失去平衡，立即退左／右腳、轉身，髖部降得很低並貼受的大腿；受只有被取崩動時，腳跟才抬起。"
    },
    "nage-okuri-ashi-harai-1": {
      "text": "取須在第二及第三步改變節奏，並施崩。"
    },
    "nage-okuri-ashi-harai-2": {
      "text": "取水平掃動，沿受移動的方向摔出受，不抬起受的身體。"
    },
    "nage-sasae-1": {
      "text": "第二步後，取須斜向後移。"
    },
    "nage-sasae-2": {
      "text": "取在第三步以右／左腳為軸轉動，摔出受；不可向前踏步。"
    },
    "nage-uchi-mata-1": {
      "text": "取以大幅圓周動作轉動受，雙臂水平拉動。"
    },
    "nage-uchi-mata-2": {
      "text": "第三次旋轉時，取將受前進中的腿向上、向外掃起。"
    },
    "nage-tomoe-1": {
      "text": "取以步足前進，使受向後失去平衡。"
    },
    "nage-tomoe-2": {
      "text": "受在第三步反推並向前踏步抵抗，雙腳對齊。"
    },
    "nage-tomoe-3": {
      "text": "受開始反推時，取改變握法，左／右腳踏入受雙腳之間，降低身體，向前上方抬起以使受失去平衡。"
    },
    "nage-tomoe-4": {
      "text": "受雙腳對齊、腳跟抬起的同時，取將右／左腳置於受的腹部，將受從自己頭上摔出。"
    },
    "nage-ura-1": {
      "text": "受前進兩步攻擊，左腳、右腳／右腳、左腳。"
    },
    "nage-ura-2": {
      "text": "取在第二步避開受的打擊，以很低的姿勢依左腳、右腳／右腳、左腳順序踏前；不可雙腳同時跳入。左／右臂環抱受的腰部將其拉近，右／左掌置於受的下腹部。"
    },
    "nage-ura-3": {
      "text": "取將受從自己的左／右肩上方摔出，完成時雙肩接觸榻榻米。"
    },
    "nage-sumi-1": {
      "text": "取採自護體後退，同時抬高右／左臂，使受失去平衡。"
    },
    "nage-sumi-2": {
      "text": "受為保持平衡，右／左腳向前移，雙腳平行，採防守的自護體姿勢。"
    },
    "nage-sumi-3": {
      "text": "取右／左腳置於受雙腳之間，再次使受向前失去平衡，然後將其從頭上摔出。"
    },
    "nage-yoko-gake-1": {
      "text": "第三步，半步時，取使受向右／左前隅傾斜失去平衡，以便側向摔出。"
    },
    "nage-yoko-gake-2": {
      "text": "取右／左腳緩慢後退，一到另一腳旁，立即以左／右腳推受的腳踝；左／右手向上托拉受的右／左袖，同時將受摔至自己身旁。"
    },
    "nage-yoko-guruma-1": {
      "text": "受前進兩步攻擊，左腳、右腳／右腳、左腳。"
    },
    "nage-yoko-guruma-2": {
      "text": "取嘗試施裏投。"
    },
    "nage-yoko-guruma-3": {
      "text": "受前屈防守。"
    },
    "nage-yoko-guruma-4": {
      "text": "取使受向前失去平衡，右／左腿深滑入受的雙腿之間。"
    },
    "nage-yoko-guruma-5": {
      "text": "取向左／右側躺下，將受斜向摔出。"
    },
    "nage-uki-waza-1": {
      "text": "取採自護體後退，同時抬高右／左臂，使受失去平衡。"
    },
    "nage-uki-waza-2": {
      "text": "受為保持平衡，右／左腳向前移，採自護體。"
    },
    "nage-uki-waza-3": {
      "text": "取使受斜向前失去平衡，側身躺下，將受斜向摔出。"
    }
  }
}
